<div
  class="relative min-h-[calc(100vh-105px)] xl:min-h-[calc(100vh-90px)] flex flex-col justify-center overflow-hidden py-12 xl:py-0"
>
  <!-- Intergalactic space background canvas -->
  <app-cosmic-canvas />

  <!-- Subtle radial glow background overlays -->
  <div
    class="absolute -top-40 -left-40 w-96 h-96 bg-primary/20 rounded-full blur-[128px] pointer-events-none"
  ></div>
  <div
    class="absolute bottom-0 right-0 w-[500px] h-[500px] bg-accent/15 rounded-full blur-[150px] pointer-events-none"
  ></div>

  <app-content-container maxWidth="xlarge">
    <div
      class="grid grid-cols-1 xl:grid-cols-12 gap-8 items-center relative z-10"
    >
      <!-- Left side: Text content -->
      <div
        class="xl:col-span-7 flex flex-col items-center xl:items-start text-center xl:text-left z-20"
      >
        <!-- Title -->
        <h1
          data-hero-entrance-target="title"
          class="hero-title text-4xl sm:text-5xl xl:text-6xl font-black tracking-tight text-white leading-tight"
        >
          Alcance o próximo nível <br class="hidden sm:inline" />
          <span
            class="bg-linear-to-r from-base-content via-30% via-purple-400 to-primary bg-clip-text text-transparent"
          >
            na sua carreira Frontend!
          </span>
        </h1>

        <!-- Description -->
        <p
          data-hero-entrance-target="description"
          class="hero-description py-6 text-gray-300 text-lg sm:text-xl max-w-[620px] font-normal leading-relaxed"
        >
          Torne-se um desenvolvedor Angular de alto nível, que domina
          arquitetura enterprise e integração com IA.
        </p>

        <!-- CTA Buttons -->
        <div
          data-hero-entrance-target="cta"
          class="flex flex-col sm:flex-row items-center gap-4 w-full max-w-[400px] xl:max-w-none justify-center xl:justify-start"
        >
          <button
            class="btn btn-primary w-full sm:w-auto px-8 py-3.5 text-base font-semibold transition-all duration-300 transform hover:-translate-y-0.5"
            [appScrollTo]="'courses-section'"
          >
            Confira nossos cursos
            <i class="bi bi-arrow-right ml-1"></i>
          </button>
        </div>
      </div>

      <!-- Right side: Cosmic Hologram -->
      @if (isDesktop()) {
      <div class="flex col-span-5 justify-center items-center relative z-20">
        <app-cosmic-hologram />
      </div>
      }
    </div>

    <!-- Scroll down indicator -->
    <div class="flex justify-center relative">
      <a
        [appScrollTo]="'courses-section'"
        class="z-20 absolute top-15 sm:top-20 md:top-30 xl:top-20 cursor-pointer group flex flex-col items-center gap-1 opacity-70 hover:opacity-100 transition-opacity"
      >
        <i
          class="bi bi-arrow-down-circle text-2xl text-primary animate-bounce"
        ></i>
      </a>
    </div>
  </app-content-container>
</div>
